<authority-labs-base-dialog [dialogRef]="dialogRef" [title]="title">
  <section content>
    <div class="dd-zone-wrap">
      <nz-upload
        class="zone"
        *ngFor="let zone of zones"
        [nzBeforeUpload]="zone.beforeUpload"
        [style.width]="zone.width"
        nzType="drag"
        [nzMultiple]="true"
        [nzShowUploadList]="false"
      >
        <p class="ant-upload-drag-icon">
          <i nz-icon nzType="inbox"></i>
        </p>
        <h3>
          {{ translationPath + 'uploadZone.' + zone.namePath | transloco }}
        </h3>
        <p class="ant-upload-text">
          {{ translationPath + 'dragAndDropDescription' | transloco }}
        </p>
      </nz-upload>
    </div>

    <authority-labs-upload-queue
      class="result"
      [showProgress]="false"
      [uploadList]="uploadList"
      (removedItem)="removeItem($event)"
    ></authority-labs-upload-queue>
  </section>

  <nz-space actions>
    <ng-container nzSpaceItem>
      <button
        nz-button
        nzType="primary"
        [disabled]="!uploadList.length"
        (click)="upload()"
      >
        {{ 'button.upload' | transloco }}
      </button>
    </ng-container>
  </nz-space>
</authority-labs-base-dialog>
